import {Image} from "semantic-ui-react";

function getContent(type,content) {
    if(type==='text'){
        return <p className={'text'}>{content}</p>
    }else if(type==='list'){
        return <ul>
            {
                content.map(item=>{
                    return (<li>{item}</li>)
                })
            }
        </ul>
    }else if(type==='table'){
        return <table>
            {content.left.map((item,index)=>{
                return <tr>
                    <td>{content.left[index]}</td>
                    <td>{content.right[index]}</td>
                </tr>
            })}
        </table>
    }else if(type==='contact'){
        return <div className={'contact-div'}>
            {content.map(item=>{
                return (<div>
                <p>{item.name}</p>
                    <p>{item.mobile}</p>
                </div>)
            })}
        </div>
    }
}

function CompetitionDetails(props) {
    const { name,data,sp1,sp2 } = props;
    console.log(props);
    return (
        <div className='competition-details'>
            {/*<div className={'headline'}>*/}
            {/*    <div/>*/}
            {/*    <h2 className={'item-name'}>{name}</h2>*/}
            {/*    /!*<Image src={sp1} className={'sp1'}/>*!/*/}
            {/*    /!*<Image src={sp2} className={'sp2'}/>*!/*/}
            {/*</div>*/}
            <h2 className={'item-name'}>{name}</h2>
            {data.map(item=>{
                return (<div className={'detail-item'}>
                    <h3>{item.name}</h3>
                    {getContent(item.type,item.content)}
                </div>)
            })}
        </div>
    );
}

export default CompetitionDetails;
